import React from "react";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../../redux/initialStoreState";
import { useDispatchWrapper } from "../../../../../../hooks";
import { clearBusinessFineArtState, fetchBusinessPolicyFineArtListAsync } from "../../../../../../redux/businessPolicy/businessPolicyFineArt/businessPolicyFineArtActions";

export const useBusinessPolicyFineArt = (customerPolicyId?: number) => {
  const dispatch = useDispatchWrapper();
  const FineArtList = useSelector(
	(storeState: IStoreState) => storeState.business.fineArt.data
  );

  const fineArtDropdown = React.useMemo(() => {
	return FineArtList.map((item) => {
	  return {
		label:
		  item.incremental_number,
		value: item.incremental_number || "",
	  };
	});
  }, [FineArtList]);

  const refreshData = () => {
	if (customerPolicyId) {
		dispatch(fetchBusinessPolicyFineArtListAsync(Number(customerPolicyId), "ACTIVE"));
	  }
  }

  React.useEffect(() => {
	if (customerPolicyId) {
	  dispatch(fetchBusinessPolicyFineArtListAsync(Number(customerPolicyId), "ACTIVE"));
	}
	return () => {
	  dispatch(clearBusinessFineArtState());
	};
  }, []);

  return { fineArtDropdown, refreshData };
};
